/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import MoserObject from './MoserObject';
import InstanceType from './InstanceType';
import KeyConstraintType from './KeyConstraintType';
import KeyCompositionType from './KeyCompositionType';
import HighLevelDataType from './HighLevelDataType';
import ItemScanner from './ItemScanner';
import RegularAggregateType from './RegularAggregateType';
import SqlOperatorType from './SqlOperatorType';
//@import BaseMoserObject (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (runtime) // getModuleObject
//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (static) // InstanceType
//@import com/ibm/bi/platform/moser/common/generated/metadata/KeyConstraintType (static) // KeyConstraintType
//@import com/ibm/bi/platform/moser/common/generated/metadata/KeyCompositionType (static) // KeyCompositionType
//@import com/ibm/bi/platform/moser/common/generated/metadata/HighLevelDataType (static) // HighLevelDataType
//@import com/ibm/bi/platform/moser/common/utils/ItemScanner (runtime) // replaceIdForExpr, collectIdentifiers
//@import com/ibm/bi/platform/moser/common/generated/metadata/RegularAggregateType (static) // RegularAggregateType
//@import com/ibm/bi/platform/moser/common/generated/metadata/SqlOperatorType (static) // SqlOperatorType

/**
 * util class for setting property vale.
 */
export default class PropertySetter extends BaseMoserObject{

	static updateModuleReference(obj, oldValue, value) {
		if (oldValue == null || value == null || value == oldValue) {
			if (value == null) {
				obj.idForExpression = null;
			}
			return;
		}
		var objType = obj.getObjectType();
		if ("Calculation" == objType || "Filter" == objType) {
			var module = MoserObject.getModuleObject(obj);
			if (!module) {
				return;
			}
			if (PropertySetter.getParentQuerySubject(obj)) {
				var f = obj;
				var oldIdForExpr = f.basicGetIdForExpression();
				var newIdForExpr = null;
				if (oldIdForExpr != null && oldIdForExpr.length > oldValue.length) {
					newIdForExpr = oldIdForExpr.substring(0, oldIdForExpr.length - oldValue.length) + value;
					f.idForExpression = newIdForExpr;
				}
				PropertySetter._updateExpressionForQueryItem(module, obj, oldIdForExpr, newIdForExpr);
				return;
			}
			PropertySetter._updateMDTVReference(module.basicGetMetadataTreeView(), oldValue, value);
			obj.idForExpression = value;
			PropertySetter._updateExpressionForGlobalCalculationFilter(module, obj, oldValue, value);
			return;
		}
		if ("QuerySubject" == objType) {
			var module = MoserObject.getModuleObject(obj);
			if (!module) {
				return;
			}
			PropertySetter._updateMDTVReference(module.basicGetMetadataTreeView(), oldValue, value);
			PropertySetter._updateRelationshipListReference(module.basicGetRelationship(), oldValue, value);
			PropertySetter._updateQuerySubjectListReference(module.basicGetQuerySubject(), oldValue, value);
			var qs = obj;
			qs.idForExpression = value;
			PropertySetter.updateIdForExpression(qs.basicGetItem(), value);
			PropertySetter._updateExpressionForQuerySubject(module, obj, oldValue, value);
			return;
		}
		if ("QueryItem" == objType) {
			var qs = PropertySetter.getParentQuerySubject(obj);
			var module = MoserObject.getModuleObject(qs);
			if (!module || !qs) {
				return;
			}
			var qsId = qs.identifier;
			var qi = obj;
			var oldIdForExpr = qi.basicGetIdForExpression();
			var newIdForExpr = null;
			if (oldIdForExpr != null && oldIdForExpr.length > oldValue.length) {
				newIdForExpr = oldIdForExpr.substring(0, oldIdForExpr.length - oldValue.length) + value;
				qi.idForExpression = newIdForExpr;
			}
			PropertySetter._updateItemNormalization(qs.getItemNormalization(), oldValue, value);
			var drills = module.drillGroup;
			if (newIdForExpr != null && drills) {
				for (var __i_enFor0 = 0, __exp_enFor0 = drills, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var dg = __exp_enFor0[__i_enFor0];
					if (!dg.segment) {
						continue;
					}
					for (var __i_enFor1 = 0, __exp_enFor1 = dg.segment, __len_enFor1 = __exp_enFor1.length;
							__i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var sg = __exp_enFor1[__i_enFor1];
						if (oldIdForExpr == sg.ref) {
							sg.ref = newIdForExpr;
						}
					}
				}
			}
			PropertySetter._updateItemTypeListQueryItemReference(qs.basicGetItem(), oldValue, value);
			var relationships = module.relationship;
			if (relationships) {
				for (var __i_enFor2 = 0, __exp_enFor2 = relationships, __len_enFor2 = __exp_enFor2.length;
						__i_enFor2 < __len_enFor2; ++__i_enFor2) {
					var r = __exp_enFor2[__i_enFor2];
					var links = r.link;
					if (!links || links.length==0) {
						continue;
					}
					var left = r.left;
					var right = r.right;
					if (qsId == left.ref) {
						for (var __i_enFor3 = 0, __exp_enFor3 = links, __len_enFor3 = __exp_enFor3.length;
								__i_enFor3 < __len_enFor3; ++__i_enFor3) {
							var l = __exp_enFor3[__i_enFor3];
							if (oldValue == l.leftRef) {
								l.leftRef = value;
							}
						}
					} else if (qsId == right.ref) {
						for (var __i_enFor4 = 0, __exp_enFor4 = links, __len_enFor4 = __exp_enFor4.length;
								__i_enFor4 < __len_enFor4; ++__i_enFor4) {
							var l = __exp_enFor4[__i_enFor4];
							if (oldValue == l.rightRef) {
								l.rightRef = value;
							}
						}
					}
				}
			}
			if (newIdForExpr != null && module.querySubject) {
				for (var __i_enFor5 = 0, __exp_enFor5 = module.querySubject, __len_enFor5 = __exp_enFor5.length;
						__i_enFor5 < __len_enFor5; ++__i_enFor5) {
					var aQS = __exp_enFor5[__i_enFor5];
					PropertySetter._updateItemTypeListReference(aQS.basicGetItem(), oldIdForExpr, newIdForExpr);
				}
			}
			PropertySetter._updateExpressionForQueryItem(module, obj, oldIdForExpr, newIdForExpr);
			return;
		}
	}

	static _updateItemNormalization(itemNorm, oldId, newId) {
		if (!itemNorm) {
			return;
		}
		var groups = itemNorm.basicGetItemNormalizationGroup();
		if (!groups) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = groups, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var grp = __exp_enFor0[__i_enFor0];
			if (grp.key && grp.key.itemRef != null && grp.key.itemRef == oldId) {
				grp.key.itemRef = newId;
			}
			if (!grp.attribute) {
				continue;
			}
			for (var __i_enFor1 = 0, __exp_enFor1 = grp.attribute, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var attr = __exp_enFor1[__i_enFor1];
				if (attr.itemRef != null && attr.itemRef == oldId) {
					attr.itemRef = newId;
				}
			}
		}
	}

	static _updateItemTypeListQueryItemReference(itemTypes, oldId, newId) {
		if (!itemTypes) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = itemTypes, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itemType = __exp_enFor0[__i_enFor0];
			PropertySetter._updateItemTypeQueryItemReference(itemType, oldId, newId);
		}
	}

	static _updateItemTypeQueryItemReference(itemType, oldId, newId) {
		var qi = itemType.getQueryItem();
		if (qi) {
			if (qi.facetDefinition && qi.facetDefinition.sortList && qi.facetDefinition.sortList.sortItem) {
				for (var __i_enFor0 = 0, __exp_enFor0 = qi.facetDefinition.sortList.sortItem, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var s = __exp_enFor0[__i_enFor0];
					if (oldId == s.ref) {
						s.ref = newId;
					}
				}
			}
			PropertySetter._updateItemTypeListQueryItemReference(qi.basicGetItem(), oldId, newId);
			return;
		}
		var folder = itemType.getFolder();
		if (folder) {
			PropertySetter._updateItemTypeListQueryItemReference(folder.basicGetItem(), oldId, newId);
			return;
		}
	}

	static getParentQuerySubject(moserObj) {
		if (!moserObj) {
			return null;
		}
		var parent = moserObj.getParent();
		if (!parent) {
			return null;
		}
		var objType = parent.getObjectType();
		if ("QuerySubject" == objType) {
			return parent;
		}
		if ("Module" == objType) {
			return null;
		}
		return PropertySetter.getParentQuerySubject(parent);
	}

	/**
	 * update MDTV reference after Identifier of the Object is changed.
	 * @param {Array} mdtv 		- MDTV.
	 * @param {String} oldId 		- old Identifier.
	 * @param {String} newId 		- new Identifier.
	 */
	static _updateMDTVReference(mdtv, oldId, newId) {
		if (!mdtv) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = mdtv, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var folderType = __exp_enFor0[__i_enFor0];
			PropertySetter._updateFolderTypeReference(folderType, oldId, newId);
		}
	}

	/**
	 * update FolderType reference after Identifier of the Object is changed.
	 * @param {FolderType} folderType 	- FolderType.
	 * @param {String} oldId 			- old Identifier.
	 * @param {String} newId 			- new Identifier.
	 */
	static _updateFolderTypeReference(folderType, oldId, newId) {
		var folderItemTypes = folderType.basicGetFolderItem();
		if (!folderItemTypes) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = folderItemTypes, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var folderItemType = __exp_enFor0[__i_enFor0];
			var ref = folderItemType.getRef();
			if (oldId == ref) {
				folderItemType.ref = newId;
			}
			var nestedFolder = folderItemType.getFolder();
			if (!nestedFolder) {
				continue;
			}
			PropertySetter._updateFolderTypeReference(nestedFolder, oldId, newId);
		}
	}

	/**
	 * update reference in Relationships after Identifier of the Object is changed.
	 * @param {Array} relationships 		- Relationships.
	 * @param {String} oldId 				- old Identifier.
	 * @param {String} newId 				- new Identifier.
	 */
	static _updateRelationshipListReference(relationships, oldId, newId) {
		if (!relationships) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = relationships, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var relationship = __exp_enFor0[__i_enFor0];
			PropertySetter._updateRelationshipReference(relationship, oldId, newId);
		}
	}

	/**
	 * update Relationship reference after Identifier of the Object is changed.
	 * @param {Relationship} relationship 		- Relationship.
	 * @param {String} oldId 				- old Identifier.
	 * @param {String} newId 				- new Identifier.
	 */
	static _updateRelationshipReference(relationship, oldId, newId) {
		PropertySetter._updateCardinalityTypeReference(relationship.getLeft(), oldId, newId);
		PropertySetter._updateCardinalityTypeReference(relationship.getRight(), oldId, newId);
	}

	/**
	 * update CardinalityType reference after Identifier of the Object is changed.
	 * @param {CardinalityType} cardinality 		- CardinalityType.
	 * @param {String} oldId 				- old Identifier.
	 * @param {String} newId 				- new Identifier.
	 */
	static _updateCardinalityTypeReference(cardinality, oldId, newId) {
		var ref = cardinality.getRef();
		if (oldId == ref) {
			cardinality.ref = newId;
		}
	}

	/**
	 * update reference in QuerySubjects after Identifier of the Object is changed.
	 * @param {Array} querySubjects 		- QuerySubjects.
	 * @param {String} oldId 				- old Identifier.
	 * @param {String} newId 				- new Identifier.
	 */
	static _updateQuerySubjectListReference(querySubjects, oldId, newId) {
		if (!querySubjects) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = querySubjects, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var querySubject = __exp_enFor0[__i_enFor0];
			PropertySetter._updateQuerySubjectReference(querySubject, oldId, newId);
		}
	}

	/**
	 * update reference in QuerySubject after Identifier of the Object is changed.
	 * @param {QuerySubject} querySubject 		- QuerySubject.
	 * @param {String} oldId 				- old Identifier.
	 * @param {String} newId 				- new Identifier.
	 */
	static _updateQuerySubjectReference(querySubject, oldId, newId) {
		var ref = querySubject.basicGetRef();
		PropertySetter._updateRefList(ref, oldId, newId);
		var orgRef = querySubject.basicGetOriginalRef();
		PropertySetter._updateRefList(orgRef, oldId, newId);
		var queryOp = querySubject.getQueryOperation();
		if (queryOp) {
			PropertySetter._updateRefList(queryOp.basicGetQueryRef(), oldId, newId);
		}
		var joinOp = querySubject.getJoinOperation();
		if (joinOp) {
			PropertySetter._updateRefList(joinOp.basicGetQueryRef(), oldId, newId);
			PropertySetter._updateRelationshipListReference(joinOp.basicGetRelationship(), oldId, newId);
		}
		PropertySetter._updateItemTypeListReference(querySubject.basicGetItem(), oldId, newId);
	}

	/**
	 * update ref list.
	 * @param {Array} ref 		- ref list.
	 * @param {String} oldId 		- old Identifier.
	 * @param {String} newId 		- new Identifier.
	 */
	static _updateRefList(ref, oldId, newId) {
		if (!ref) {
			return;
		}
		for (var i = 0; i < ref.length; ++i) {
			if (oldId == ref[i]) {
				ref[i] = newId;
			}
		}
	}

	/**
	 * update reference in ItemType List after Identifier of the Object is changed.
	 * @param {Array} itemTypes 		- ItemType list.
	 * @param {String} oldId 			- old Identifier.
	 * @param {String} newId 			- new Identifier.
	 */
	static _updateItemTypeListReference(itemTypes, oldId, newId) {
		if (!itemTypes) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = itemTypes, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itemType = __exp_enFor0[__i_enFor0];
			PropertySetter._updateItemTypeReference(itemType, oldId, newId);
		}
	}

	/**
	 * update reference in ItemTypet after Identifier of the Object is changed.
	 * @param {ItemType} itemType 		- ItemType.
	 * @param {String} oldId 			- old Identifier.
	 * @param {String} newId 			- new Identifier.
	 */
	static _updateItemTypeReference(itemType, oldId, newId) {
		var qi = itemType.getQueryItem();
		if (qi) {
			var splits = qi.basicGetSplitDefinition();
			if (splits) {
				for (var __i_enFor0 = 0, __exp_enFor0 = splits, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var split = __exp_enFor0[__i_enFor0];
					var ref = split.getRef();
					if (oldId == ref) {
						split.ref = newId;
					}
				}
			}
			PropertySetter._updateItemTypeListReference(qi.basicGetItem(), oldId, newId);
			return;
		}
		var folder = itemType.getFolder();
		if (folder) {
			PropertySetter._updateItemTypeListReference(folder.basicGetItem(), oldId, newId);
			return;
		}
	}

	/**
	 * update IdforExpression.
	 * @param {Array} items  items
	 * @param {String} parentIdForExpr  parent IdforExpression.
	 */
	static updateIdForExpression(items, parentIdForExpr) {
		if (!items) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itm = __exp_enFor0[__i_enFor0];
			var qi = itm.getQueryItem();
			if (qi) {
				var newIdforExpr = parentIdForExpr + "." + qi.getIdentifier();
				qi.idForExpression = newIdforExpr;
				PropertySetter.updateIdForExpression(qi.basicGetItem(), newIdforExpr);
				continue;
			}
			var flt = itm.getFilter();
			if (flt) {
				var newIdforExpr = parentIdForExpr + "." + flt.getIdentifier();
				flt.idForExpression = newIdforExpr;
				continue;
			}
			var folder = itm.getFolder();
			if (folder) {
				PropertySetter.updateIdForExpression(folder.basicGetItem(), parentIdForExpr);
			}
		}
	}

	static resetReferencedObject(module, qiId, qiIdForExpression, qsId) {
		var relationships = module.relationship;
		if (relationships) {
			for (var __i_enFor0 = 0, __exp_enFor0 = relationships, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var r = __exp_enFor0[__i_enFor0];
				var links = r.link;
				if (!links || links.length==0) {
					continue;
				}
				var left = r.left;
				var right = r.right;
				if (qsId == left.ref) {
					for (var __i_enFor1 = 0, __exp_enFor1 = links, __len_enFor1 = __exp_enFor1.length;
							__i_enFor1 < __len_enFor1; ++__i_enFor1) {
						var l = __exp_enFor1[__i_enFor1];
						if (qiId == l.leftRef) {
							l.setReferencedObjectLeft(null);
						}
					}
				} else if (qsId == right.ref) {
					for (var __i_enFor2 = 0, __exp_enFor2 = links, __len_enFor2 = __exp_enFor2.length;
							__i_enFor2 < __len_enFor2; ++__i_enFor2) {
						var l = __exp_enFor2[__i_enFor2];
						if (qiId == l.rightRef) {
							l.setReferencedObjectRight(null);
						}
					}
				}
			}
		}
		var drills = module.drillGroup;
		if (qiIdForExpression != null && drills) {
			for (var __i_enFor3 = 0, __exp_enFor3 = drills, __len_enFor3 = __exp_enFor3.length;
					__i_enFor3 < __len_enFor3; ++__i_enFor3) {
				var dg = __exp_enFor3[__i_enFor3];
				var segs = dg.segment;
				if (!segs) {
					continue;
				}
				for (var __i_enFor4 = 0, __exp_enFor4 = segs, __len_enFor4 = __exp_enFor4.length;
						__i_enFor4 < __len_enFor4; ++__i_enFor4) {
					var sg = __exp_enFor4[__i_enFor4];
					if (qiIdForExpression == sg.ref) {
						sg.setReferencedObject(null);
					}
				}
			}
		}
	}

	static resolveIdForExpression(obj) {
		if (!obj) {
			return;
		}
		var module = MoserObject.getModuleObject(obj);
		if (!module || !(module.isOverrideMode())) {
			return;
		}
		var objType = obj.getObjectType();
		if ("QuerySubject" == objType) {
			obj.idForExpression = (obj).identifier;
			return;
		}
		if ("Calculation" == objType) {
			obj.idForExpression = (obj).identifier;
			return;
		}
		if ("QueryItem" == objType || "Filter" == objType) {
			var id = (obj).identifier;
			if (id == null || id.length === 0) {
				return;
			}
			var parts = [];
			parts.push(id);
			var parent = obj.getParent();
			while (parent) {
				objType = parent.getObjectType();
				if ("Module" == objType) {
					break;
				}
				if ("QuerySubject" == objType) {
					id = (parent).identifier;
					if (id == null || id.length === 0) {
						return;
					}
					parts.push(id);
					break;
				}
				if ("QueryItem" == objType) {
					id = (parent).identifier;
					if (id == null || id.length === 0) {
						return;
					}
					parts.push(id);
				}
				parent = parent.getParent();
			}
			var sb = "";
			var s = parts.length - 1;
			for (var i = s; i >= 0; --i) {
				if (i != s) {
					sb+=(".");
				}
				sb+=(parts[i]);
			}
			obj.idForExpression = sb;
		}
	}

	static isEmptyRef(v) {
		return v == null || v.length === 0 || "none" == v || "None" == v || "NONE" == v;
	}

	static getAllQueryItemsInItems(items) {
		var qItems = [];
		if (!items) {
			return qItems;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			if (item.queryItem) {
				qItems.push(item.queryItem);
			} else if (item.folder) {
				Array.prototype.push.apply(qItems, PropertySetter.getAllQueryItemsInItems(item.folder.item));
			}
		}
		return qItems;
	}

	static getAllQueryItemsInQuerySubject(qs) {
		return PropertySetter.getAllQueryItemsInItems(qs.item);
	}

	static _resetSplitToQueryItem(module, srcQI, bset) {
		var idForExpr = srcQI.idForExpression;
		if (idForExpr != null && !(idForExpr.length === 0)) {
			for (var __i_enFor0 = 0, __exp_enFor0 = module.querySubject, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var aQS = __exp_enFor0[__i_enFor0];
				for (var __i_enFor1 = 0, __exp_enFor1 = PropertySetter.getAllQueryItemsInQuerySubject(aQS), __len_enFor1 = __exp_enFor1.length;
						__i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var aQI = __exp_enFor1[__i_enFor1];
					if (srcQI === aQI) {
						continue;
					}
					var sp = aQI.splitDefinition;
					if (!sp || sp.length==0 || !(idForExpr == sp[0].ref)) {
						continue;
					}
					if (aQI.item) {
						aQI.item.length = 0;
					}
					if (bset) {
						PropertySetter._addQueryItemsForSplit(srcQI, aQI);
					}
				}
			}
		}
	}

	/**
	 * generate dynamic filters after split reference is set.
	 * @param {MoserObject} obj 			SplitType.
	 * @param {String} oldValue 		old value.
	 * @param {String} newValue 		new value.
	 */
	static _updateSplitRef(obj, oldValue, newValue) {
		var bOldEmpty = PropertySetter.isEmptyRef(oldValue);
		var bNewEmpty = PropertySetter.isEmptyRef(newValue);
		if (bOldEmpty && bNewEmpty || !bOldEmpty && !bNewEmpty && newValue == oldValue) {
			return;
		}
		var splitDef = obj;
		if (!(InstanceType.REFERENCE === splitDef.instanceType)) {
			return;
		}
		var module = MoserObject.getModuleObject(splitDef);
		if (!module || !(module.isOverrideMode())) {
			return;
		}
		var parent = splitDef.getParent();
		if (!parent || !("QueryItem" == parent.getObjectType())) {
			return;
		}
		var targetQueryItem = parent;
		splitDef.folderLabel = null;
		if (targetQueryItem.item) {
			targetQueryItem.item.length = 0;
		}
		if (bNewEmpty) {
			if (!bOldEmpty) {
				var oldParts = oldValue.split(new RegExp("\\."));
				if (oldParts.length == 1) {
					PropertySetter._resetSplitToQueryItem(module, targetQueryItem, false);
				}
			}
			return;
		}
		var parts = newValue.split(new RegExp("\\."));
		if (parts.length == 1) {
			splitDef.folderLabel = PropertySetter.splitToQuerySubject(targetQueryItem, splitDef, module, parts[0]);
			PropertySetter._resetSplitToQueryItem(module, targetQueryItem, true);
		} else {
			splitDef.folderLabel = PropertySetter.splitToComparableQueryItem(targetQueryItem, splitDef, module, parts[0], newValue);
		}
	}

	static _getQuerySubjectById(module, id) {
		if (!module.querySubject) {
			return null;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = module.querySubject, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var qs = __exp_enFor0[__i_enFor0];
			if (id == qs.identifier || id == qs.idForExpression) {
				return qs;
			}
		}
		return null;
	}

	static ensureIdForExpression(parentId, items, allQueryItems) {
		if (!items) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itm = __exp_enFor0[__i_enFor0];
			if (itm.queryItem) {
				if (itm.queryItem.idForExpression == null) {
					itm.queryItem.idForExpression = parentId + "." + itm.queryItem.identifier;
				}
				allQueryItems[itm.queryItem.idForExpression] = itm.queryItem;
				if (itm.queryItem.item) {
					PropertySetter.ensureIdForExpression(itm.queryItem.idForExpression, itm.queryItem.item, allQueryItems);
				}
				continue;
			}
			if (itm.filter) {
				if (itm.filter.idForExpression == null) {
					itm.filter.idForExpression = parentId + "." + itm.filter.identifier;
				}
				continue;
			}
			if (itm.folder) {
				PropertySetter.ensureIdForExpression(parentId, itm.folder.item, allQueryItems);
				continue;
			}
		}
	}

	static _needCloneQueryItem(qi, qs, allQueryItems) {
		if (!qs.itemNormalization) {
			return false;
		}
		if (!qs.itemNormalization.itemNormalizationGroup) {
			return false;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = qs.itemNormalization.itemNormalizationGroup, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var g = __exp_enFor0[__i_enFor0];
			if (!g.key) {
				continue;
			}
			if (g.key.getKeyConstraint() != KeyConstraintType.UNIQUE || g.key.getKeyComposition() != KeyCompositionType.INDEPENDENT) {
				continue;
			}
			var idforexpr = qs.identifier + "." + g.key.itemRef;
			var foundQI = allQueryItems[idforexpr];
			if (!foundQI) {
				continue;
			}
			if (PropertySetter._compatibleDT(qi, foundQI)) {
				return true;
			}
		}
		return false;
	}

	static _compatibleDT(qi, foundQI) {
		if (!qi.highlevelDatatype || !foundQI.highlevelDatatype) {
			return false;
		}
		if (qi.highlevelDatatype == HighLevelDataType.STRING && foundQI.highlevelDatatype == HighLevelDataType.STRING) {
			return true;
		}
		if ((qi.highlevelDatatype == HighLevelDataType.INTEGER || qi.highlevelDatatype == HighLevelDataType.DECIMAL) && (foundQI.highlevelDatatype == HighLevelDataType.INTEGER || foundQI.highlevelDatatype == HighLevelDataType.DECIMAL)) {
			return true;
		}
		if ((qi.highlevelDatatype == HighLevelDataType.DATE || qi.highlevelDatatype == HighLevelDataType.DATETIME) && (foundQI.highlevelDatatype == HighLevelDataType.DATE || foundQI.highlevelDatatype == HighLevelDataType.DATETIME)) {
			return true;
		}
		return false;
	}

	static splitToQuerySubject(targetQueryItem, splitDef, module, qsId) {
		var sourceQuerySubject = PropertySetter._getQuerySubjectById(module, qsId);
		if (!sourceQuerySubject) {
			return null;
		}
		if (!sourceQuerySubject.item || sourceQuerySubject.item.length==0) {
			return null;
		}
		var allQueryItems = {};
		PropertySetter.ensureIdForExpression(sourceQuerySubject.identifier, sourceQuerySubject.item, allQueryItems);
		var parentIdForExpr = targetQueryItem.getIdForExpression();
		var bNeedCloneQueryItem = PropertySetter._needCloneQueryItem(targetQueryItem, sourceQuerySubject, allQueryItems);
		for (var __i_enFor0 = 0, __exp_enFor0 = sourceQuerySubject.item, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var itm = __exp_enFor0[__i_enFor0];
			try {
				var newItm = itm.clone();
				var b = [false, false];
				PropertySetter._adjustExpressionOfQueryItemFilter(newItm, b, parentIdForExpr, bNeedCloneQueryItem);
				if (b[0] && !b[1]) {
					if (!targetQueryItem.item) {
						targetQueryItem.item = [];
					}
					targetQueryItem.item.push(newItm);
					newItm._parent = targetQueryItem;
				}
			} catch (e) {
				throw e;
			}

		}
		return sourceQuerySubject.label;
	}

	static _adjustExpressionOfQueryItemFilter(item, b, pId, bNeedCloneQueryItem) {
		if (item.namedSet || item.itemHierarchy || !bNeedCloneQueryItem && item.queryItem) {
			b[1] = true;
			return;
		}
		if (item.queryItem) {
			b[0] = true;
			item.queryItem.expression = item.queryItem.idForExpression;
			item.queryItem.idForExpression = pId + "." + item.queryItem.identifier;
			item.queryItem.instanceType = InstanceType.REFERENCE;
			if (item.queryItem.item) {
				for (var __i_enFor0 = 0, __exp_enFor0 = item.queryItem.item, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var t = __exp_enFor0[__i_enFor0];
					PropertySetter._adjustExpressionOfQueryItemFilter(t, b, item.queryItem.idForExpression, bNeedCloneQueryItem);
				}
			}
			return;
		}
		if (item.filter) {
			b[0] = true;
			item.filter.idForExpression = pId + "." + item.filter.identifier;
			item.filter.instanceType = InstanceType.REFERENCE;
			return;
		}
		if (item.folder && item.folder.item) {
			for (var __i_enFor1 = 0, __exp_enFor1 = item.folder.item, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var t = __exp_enFor1[__i_enFor1];
				PropertySetter._adjustExpressionOfQueryItemFilter(t, b, pId, bNeedCloneQueryItem);
			}
		}
	}

	static splitToComparableQueryItem(targetQueryItem, splitDef, module, qsId, idforexprSrcQueryItem) {
		var idforexprTarget = targetQueryItem.getIdForExpression();
		if (idforexprSrcQueryItem == idforexprTarget) {
			return null;
		}
		var srcQuerySubject = PropertySetter._getQuerySubjectById(module, qsId);
		if (!srcQuerySubject) {
			return null;
		}
		var allQueryItems = {};
		PropertySetter.ensureIdForExpression(srcQuerySubject.identifier, srcQuerySubject.item, allQueryItems);
		var srcQueryItem = allQueryItems[idforexprSrcQueryItem];
		if (!srcQueryItem) {
			return null;
		}
		return PropertySetter._addQueryItemsForSplit(srcQueryItem, targetQueryItem);
	}

	static _addQueryItemsForSplit(srcQueryItem, targetQueryItem) {
		if (!srcQueryItem.item || srcQueryItem.item.length==0) {
			return null;
		}
		try {
			var targetQIClone = targetQueryItem.clone();
			targetQIClone.item = null;
			targetQIClone.splitDefinition = null;
			for (var __i_enFor0 = 0, __exp_enFor0 = srcQueryItem.item, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var itm = __exp_enFor0[__i_enFor0];
				var newItm = itm.clone();
				var b = [false, false];
				PropertySetter._adjustExpressionFromFilterToQueryItem(newItm, b, targetQIClone, srcQueryItem);
				if (b[0] && !b[1]) {
					if (!targetQueryItem.item) {
						targetQueryItem.item = [];
					}
					targetQueryItem.item.push(newItm);
					newItm._parent = targetQueryItem;
				}
			}
		} catch (e) {
			throw e;
		}

		return srcQueryItem.label;
	}

	static _adjustExpressionFromFilterToQueryItem(item, b, targetQI, srcQueryItem) {
		if (item.getNamedSet() || item.getItemHierarchy() || item.getQueryItem()) {
			b[1] = true;
			return;
		}
		if (item.filter) {
			b[0] = true;
			try {
				var newQI = targetQI.clone();
				newQI.identifier = item.filter.identifier;
				newQI.instanceType = InstanceType.REFERENCE;
				if (item.filter.label != null) {
					newQI.label = item.filter.label + " [" + targetQI.label + "]";
				}
				newQI.expression = "case when " + item.filter.idForExpression + " then #$_this.parent.idForExpression# end";
				newQI.ref = null;
				newQI.idForExpression = targetQI.idForExpression + "." + newQI.identifier;
				item.queryItem = newQI;
				newQI._parent = item;
				item.filter = null;
			} catch (e) {
				throw e;
			}

			return;
		}
		if (item.folder && item.folder.item) {
			for (var __i_enFor0 = 0, __exp_enFor0 = item.folder.item, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var t = __exp_enFor0[__i_enFor0];
				PropertySetter._adjustExpressionFromFilterToQueryItem(t, b, targetQI, srcQueryItem);
			}
		}
	}

	static _updateExpressionForGlobalCalculationFilter(module, obj, oldId, newId) {
		var candidates = [];
		var exprs = [];
		var types = [];
		var idforExprs = [];
		PropertySetter._collectCandidatesForGlobaleCalculationFilter(module, obj, candidates, exprs, types, idforExprs);
		for (var i = 0; i < candidates.length; ++i) {
			var o = candidates[i];
			var objType = types[i];
			var jFunc = PropertySetter._getJSONFunctionDef(o);
			if (jFunc && jFunc["elementOperands"] != null) {
				var ops = jFunc["elementOperands"];
				var b = false;
				for (var j = 0; j < ops.length; ++j) {
					if (oldId == ops[j]) {
						ops[j] = newId;
						b = true;
						break;
					}
				}
				if (b) {
					PropertySetter._updateJSONFunctionDef(o, jFunc);
					PropertySetter._updateExpressionStringForGlobalCalculationFilter(o, objType, exprs[i], idforExprs[i], oldId, newId);
				}
				continue;
			}
			PropertySetter._updateExpressionStringForGlobalCalculationFilter(o, objType, exprs[i], idforExprs[i], oldId, newId);
		}
	}

	static _updateExpressionForQuerySubject(module, obj, oldId, newId) {
		var candidates = [];
		var exprs = [];
		var types = [];
		var idforExprs = [];
		PropertySetter._collectCandidatesForQuerySubject(module, obj, candidates, exprs, types, idforExprs, oldId);
		for (var i = 0; i < candidates.length; ++i) {
			var o = candidates[i];
			var objType = types[i];
			var jFunc = PropertySetter._getJSONFunctionDef(o);
			if (jFunc && jFunc["elementOperands"] != null) {
				var ops = jFunc["elementOperands"];
				var b = false;
				for (var j = 0; j < ops.length; ++j) {
					var idforexpr = ops[j];
					var parts = idforexpr.split(new RegExp("\\."));
					if (parts.length > 1 && oldId == parts[0]) {
						parts[0] = newId;
						var sb = "";
						for (var k = 0; k < parts.length; ++k) {
							if (k != 0) {
								sb+=(".");
							}
							sb+=(parts[k]);
						}
						var newElem = sb;
						ops[j] = newElem;
						b = true;
						break;
					}
				}
				if (b) {
					PropertySetter._updateJSONFunctionDef(o, jFunc);
					PropertySetter._updateExpressionStringForQuerySubject(o, objType, exprs[i], idforExprs[i], oldId, newId);
				}
				continue;
			}
			PropertySetter._updateExpressionStringForQuerySubject(o, objType, exprs[i], idforExprs[i], oldId, newId);
		}
	}

	static _updateExpressionForQueryItem(module, obj, oldIdforExpr, newIdforExpr) {
		var candidates = [];
		var exprs = [];
		var types = [];
		var idforExprs = [];
		PropertySetter._collectCandidatesForQuerySubject(module, obj, candidates, exprs, types, idforExprs, null);
		for (var i = 0; i < candidates.length; ++i) {
			var o = candidates[i];
			var objType = types[i];
			var jFunc = PropertySetter._getJSONFunctionDef(o);
			if (jFunc && jFunc["elementOperands"] != null) {
				var ops = jFunc["elementOperands"];
				var b = false;
				for (var j = 0; j < ops.length; ++j) {
					if (oldIdforExpr == ops[j]) {
						ops[j] = newIdforExpr;
						b = true;
						break;
					}
				}
				if (b) {
					PropertySetter._updateJSONFunctionDef(o, jFunc);
					PropertySetter._updateExpressionStringForQueryItem(o, objType, exprs[i], idforExprs[i], oldIdforExpr, newIdforExpr);
				}
				continue;
			}
			PropertySetter._updateExpressionStringForQueryItem(o, objType, exprs[i], idforExprs[i], oldIdforExpr, newIdforExpr);
		}
	}

	static _getJSONFunctionDef(o) {
		return PropertySetter._getJSONPropertyValue(o, "_MUI_expr");
	}

	static _getJSONPropertyValue(o, propName) {
		var props = o.basicGetProperty();
		if (!props) {
			return null;
		}
		var jFunc;
		for (var __i_enFor0 = 0, __exp_enFor0 = props, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var p = __exp_enFor0[__i_enFor0];
			if (propName == p.getName()) {
				var funcStr = p.getValue();
				if (funcStr != null) {
					try {
						jFunc = JSON.parse(funcStr);
					} catch (e) {
						throw e;
					}

				}
				break;
			}
		}
		return jFunc;
	}

	static _updateJSONFunctionDef(o, j) {
		var props = o.basicGetProperty();
		if (!props) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = props, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var p = __exp_enFor0[__i_enFor0];
			if ("_MUI_expr" == p.getName()) {
				try {
					p.value = JSON.stringify(j);
				} catch (e) {
					throw e;
				}

				break;
			}
		}
	}

	static _updateExpressionStringForGlobalCalculationFilter(targetObj, targetObjType, targetExpr, targetIdforExpr, oldId, newId) {
		var newExpr = ItemScanner.replaceIdForExpr(targetObjType, targetExpr, targetIdforExpr, "Calculation", oldId, newId);
		if (newExpr != null) {
			if ("Calculation" == targetObjType) {
				(targetObj).expression = newExpr;
			} else {
				(targetObj).expression = newExpr;
			}
		}
	}

	static _updateExpressionStringForQuerySubject(targetObj, targetObjType, targetExpr, sameQS, oldId, newId) {
		var newExpr = ItemScanner.replaceIdForExpr(targetObjType, targetExpr, sameQS, "QuerySubject", oldId, newId);
		if (newExpr != null) {
			var realObjType = targetObj.getObjectType();
			if ("Calculation" == realObjType) {
				(targetObj).expression = newExpr;
			} else if ("Filter" == realObjType) {
				(targetObj).expression = newExpr;
			} else if ("QueryItem" == realObjType) {
				(targetObj).expression = newExpr;
			}
		}
	}

	static _updateExpressionStringForQueryItem(targetObj, targetObjType, targetExpr, targetIdforExpr, oldIdforExpr, newIdforExpr) {
		var newExpr = ItemScanner.replaceIdForExpr(targetObjType, targetExpr, targetIdforExpr, "QueryItem", oldIdforExpr, newIdforExpr);
		if (newExpr != null) {
			var realObjType = targetObj.getObjectType();
			if ("Calculation" == realObjType) {
				(targetObj).expression = newExpr;
			} else if ("Filter" == realObjType) {
				(targetObj).expression = newExpr;
			} else if ("QueryItem" == realObjType) {
				(targetObj).expression = newExpr;
			}
		}
	}

	static setIdentifier(obj, value, idforExprToNewExpr) {
		if (idforExprToNewExpr) {
			var candidates = [];
			var exprs = [];
			var types = [];
			var idforExprs = [];
			PropertySetter._collectCandidates(obj, candidates, exprs, types, idforExprs);
			for (var i = 0; i < candidates.length; ++i) {
				var newExpr = idforExprToNewExpr[idforExprs[i]];
				if (newExpr != null) {
					var objType = types[i];
					if ("Calculation" == objType) {
						var c = candidates[i];
						c.setExpression(newExpr);
					} else if ("Filter" == objType) {
						var f = candidates[i];
						f.setExpression(newExpr);
					} else if ("QueryItem" == objType) {
						var qi = candidates[i];
						qi.setExpression(newExpr);
					}
				}
			}
		}
		obj.setIdentifier(value);
	}

	static getExtractIdentifiersSpec(obj, value) {
		var oldIdForExpr = obj.idForExpression;
		var oldValue = obj.identifier;
		var module = MoserObject.getModuleObject(obj);
		if (!module || oldValue == null || oldIdForExpr == null || oldValue == value) {
			return null;
		}
		var objType = obj.getObjectType();
		var candidates = [];
		var exprs = [];
		var types = [];
		var idforExprs = [];
		PropertySetter._collectCandidates(obj, candidates, exprs, types, idforExprs);
		if (candidates.length==0) {
			return null;
		}
		return PropertySetter.buildSpec(oldIdForExpr, objType, value, exprs, types, idforExprs);
	}

	static _collectCandidates(obj, candidates, exprs, types, idforExprs) {
		var module = MoserObject.getModuleObject(obj);
		if (!module) {
			return;
		}
		var objType = obj.getObjectType();
		if ("Calculation" == objType || "Filter" == objType) {
			PropertySetter._collectCandidatesForGlobaleCalculationFilter(module, obj, candidates, exprs, types, idforExprs);
		} else if ("QuerySubject" == objType) {
			PropertySetter._collectCandidatesForQuerySubject(module, obj, candidates, exprs, types, idforExprs, null);
		} else if ("QueryItem" == objType) {
			PropertySetter._collectCandidatesForQuerySubject(module, obj, candidates, exprs, types, idforExprs, null);
		}
	}

	static _objectWithExpr(expr, idForExpr) {
		return expr != null && !(expr.length === 0) && idForExpr != null && !(idForExpr.length === 0);
	}

	static _collectCandidatesForGlobaleCalculationFilter(module, obj, candidates, exprs, types, idforExprs) {
		var calcs = module.basicGetCalculation();
		if (calcs) {
			for (var __i_enFor0 = 0, __exp_enFor0 = calcs, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var c = __exp_enFor0[__i_enFor0];
				if (!(c === obj) && PropertySetter._objectWithExpr(c.expression, c.idForExpression)) {
					candidates.push(c);
					exprs.push(c.expression);
					types.push("Calculation");
					idforExprs.push(c.idForExpression);
				}
			}
		}
		var filters = module.basicGetFilter();
		if (filters) {
			for (var __i_enFor1 = 0, __exp_enFor1 = filters, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var f = __exp_enFor1[__i_enFor1];
				if (!(f === obj) && PropertySetter._objectWithExpr(f.expression, f.idForExpression)) {
					candidates.push(f);
					exprs.push(f.expression);
					types.push("Filter");
					idforExprs.push(f.idForExpression);
				}
			}
		}
	}

	static getItemsWithQueryItemFilter(items) {
		var rtItems = [];
		if (!items) {
			return rtItems;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = items, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			if (item.getQueryItem() || item.getFilter()) {
				rtItems.push(item);
			} else if (item.getFolder()) {
				Array.prototype.push.apply(rtItems, PropertySetter.getItemsWithQueryItemFilter(item.getFolder().basicGetItem()));
			}
		}
		return rtItems;
	}

	static _collectCandidatesForQuerySubject(module, obj, candidates, exprs, types, idforExprs, oldQSId) {
		var tp = obj.getObjectType();
		var qs;
		var oldQSIdforExpr;
		if ("QuerySubject" == tp) {
			qs = obj;
			if (oldQSId != null) {
				oldQSIdforExpr = oldQSId;
			} else {
				oldQSIdforExpr = qs.idForExpression;
			}
		} else if ("QueryItem" == tp || "Filter" == tp) {
			qs = PropertySetter.getParentQuerySubject(obj);
			oldQSIdforExpr = qs.idForExpression;
		} else {
			return;
		}
		if (oldQSIdforExpr == null) {
			return;
		}
		for (var __i_enFor0 = 0, __exp_enFor0 = PropertySetter.getItemsWithQueryItemFilter(qs.basicGetItem()), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var item = __exp_enFor0[__i_enFor0];
			var qi = item.getQueryItem();
			if (qi) {
				if (qi === obj || !(PropertySetter._objectWithExpr(qi.expression, qi.idForExpression))) {
					continue;
				}
				candidates.push(qi);
				exprs.push(qi.expression);
				types.push("QueryItem");
				idforExprs.push(qi.idForExpression);
			} else {
				var df = item.getFilter();
				if (df === obj || PropertySetter._objectWithExpr(df.expression, df.idForExpression)) {
					candidates.push(df);
					exprs.push(df.expression);
					types.push("QueryItem");
					idforExprs.push(df.idForExpression);
				}
			}
		}
		var embeddedFilters = qs.basicGetFilter();
		if (embeddedFilters) {
			for (var __i_enFor1 = 0, __exp_enFor1 = embeddedFilters, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var ef = __exp_enFor1[__i_enFor1];
				if (PropertySetter._objectWithExpr(ef.expression, ef.idForExpression)) {
					candidates.push(ef);
					exprs.push(ef.expression);
					types.push("QueryItem");
					idforExprs.push(ef.idForExpression);
				}
			}
		}
		var allQSs = module.basicGetQuerySubject();
		if (allQSs) {
			for (var __i_enFor2 = 0, __exp_enFor2 = allQSs, __len_enFor2 = __exp_enFor2.length;
					__i_enFor2 < __len_enFor2; ++__i_enFor2) {
				var aQS = __exp_enFor2[__i_enFor2];
				if (aQS === qs || !(PropertySetter._hasReference(aQS, qs, oldQSIdforExpr))) {
					continue;
				}
				for (var __i_enFor3 = 0, __exp_enFor3 = PropertySetter.getItemsWithQueryItemFilter(aQS.basicGetItem()), __len_enFor3 = __exp_enFor3.length;
						__i_enFor3 < __len_enFor3; ++__i_enFor3) {
					var item = __exp_enFor3[__i_enFor3];
					var qi = item.getQueryItem();
					if (qi && qi.regularAggregate != RegularAggregateType.CALCULATED && PropertySetter._objectWithExpr(qi.expression, qi.idForExpression)) {
						candidates.push(qi);
						exprs.push(qi.expression);
						types.push("QueryItem");
						idforExprs.push(qi.idForExpression);
					}
				}
			}
		}
		var calcs = module.basicGetCalculation();
		if (calcs) {
			for (var __i_enFor4 = 0, __exp_enFor4 = calcs, __len_enFor4 = __exp_enFor4.length;
					__i_enFor4 < __len_enFor4; ++__i_enFor4) {
				var c = __exp_enFor4[__i_enFor4];
				if (PropertySetter._objectWithExpr(c.expression, c.idForExpression)) {
					candidates.push(c);
					exprs.push(c.expression);
					types.push("Calculation");
					idforExprs.push(c.idForExpression);
				}
			}
		}
		var filters = module.basicGetFilter();
		if (filters) {
			for (var __i_enFor5 = 0, __exp_enFor5 = filters, __len_enFor5 = __exp_enFor5.length;
					__i_enFor5 < __len_enFor5; ++__i_enFor5) {
				var f = __exp_enFor5[__i_enFor5];
				if (PropertySetter._objectWithExpr(f.expression, f.idForExpression)) {
					candidates.push(f);
					exprs.push(f.expression);
					types.push("Filter");
					idforExprs.push(f.idForExpression);
				}
			}
		}
	}

	static _hasReference(aQS, qs, oldQSId) {
		var refs = aQS.basicGetRef();
		if (refs && refs.indexOf(oldQSId)> -1) {
			return true;
		}
		var joinOp = aQS.getJoinOperation();
		if (joinOp) {
			refs = joinOp.basicGetQueryRef();
			if (refs && refs.indexOf(oldQSId)> -1) {
				return true;
			}
		}
		return false;
	}

	static buildSpec(oldIdForExpr, objType, newId, exprs, types, idforExprs) {
		return "{" + PropertySetter._wrapQuote("moserFunctionType") + ":" + PropertySetter._wrapQuote("extractIdentifiers") + "," + PropertySetter._buildExpressions(exprs) + "," + PropertySetter._buildFeedback(oldIdForExpr, objType, newId, types, idforExprs) + "}";
	}

	static _buildExpressions(exprs) {
		var sb1 = "";
		for (var i = 0; i < exprs.length; ++i) {
			if (i > 0) {
				sb1+=(",");
			}
			sb1+=(PropertySetter._wrapQuote(exprs[i]));
		}
		return PropertySetter._wrapQuote("expressions") + ":[" + sb1 + "]";
	}

	static _buildFeedback(oldIdForExpr, objType, newId, types, idforExprs) {
		var sb1 = "";
		for (var i = 0; i < idforExprs.length; ++i) {
			if (i > 0) {
				sb1+=(",");
			}
			sb1+=("{");
			sb1+=(PropertySetter._wrapSlashQuote("idForExpression"));
			sb1+=(":");
			sb1+=(PropertySetter._wrapSlashQuote(idforExprs[i]));
			sb1+=(",");
			sb1+=(PropertySetter._wrapSlashQuote("type"));
			sb1+=(":");
			sb1+=(PropertySetter._wrapSlashQuote(types[i]));
			sb1+=("}");
		}
		return PropertySetter._wrapQuote("feedback") + ":" + PropertySetter._wrapQuote("{" + PropertySetter._wrapSlashQuote("idForExpression") + ":" + PropertySetter._wrapSlashQuote(oldIdForExpr) + "," + PropertySetter._wrapSlashQuote("type") + ":" + PropertySetter._wrapSlashQuote(objType) + "," + PropertySetter._wrapSlashQuote("newIdentifier") + ":" + PropertySetter._wrapSlashQuote(newId) + "," + PropertySetter._wrapSlashQuote("expressions") + ":[" + sb1 + "]}");
	}

	static _wrapQuote(s) {
		return "\"" + s + "\"";
	}

	static _wrapSlashQuote(s) {
		return "\\\"" + s + "\\\"";
	}

	static cleanQuerySubjectItemNormalization(qs, existingQI) {
		var itemNorm = qs.itemNormalization;
		if (!itemNorm) {
			return false;
		}
		var grps = itemNorm.itemNormalizationGroup;
		if (!grps || grps.length==0) {
			return false;
		}
		if (existingQI.length==0) {
			qs.itemNormalization = null;
			return true;
		}
		var bChanged = false;
		var lst = [];
		for (var __i_enFor0 = 0, __exp_enFor0 = grps, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var g = __exp_enFor0[__i_enFor0];
			lst.push(g);
		}
		for (var __i_enFor1 = 0, __exp_enFor1 = lst, __len_enFor1 = __exp_enFor1.length;
				__i_enFor1 < __len_enFor1; ++__i_enFor1) {
			var ag = __exp_enFor1[__i_enFor1];
			var bDelGrp = false;
			var attrs = ag.attribute;
			var k = ag.key;
			if (attrs && !(attrs.length==0)) {
				var sz = attrs.length;
				for (var i = sz - 1; i >= 0; --i) {
					if (!(existingQI.indexOf(attrs[i].itemRef)> -1)) {
						bChanged = true;
						attrs.splice(i, 1);
					}
				}
			}
			if (k) {
				bDelGrp = !(existingQI.indexOf(k.itemRef)> -1);
			} else {
				bDelGrp = !attrs || attrs.length==0;
			}
			if (bDelGrp) {
				bChanged = true;
				var gpId = ag.identifier;
				var paranetGrps = ag.parentGroupRef;
				var idx = grps.indexOf(ag);
				if (idx >= 0) {
					grps.splice(idx, 1);
				}
				for (var __i_enFor2 = 0, __exp_enFor2 = grps, __len_enFor2 = __exp_enFor2.length;
						__i_enFor2 < __len_enFor2; ++__i_enFor2) {
					var otherGrp = __exp_enFor2[__i_enFor2];
					var otherParanetGrps = otherGrp.parentGroupRef;
					if (otherParanetGrps && !(otherParanetGrps.length==0) && otherParanetGrps.indexOf(gpId)> -1) {
						idx = otherParanetGrps.indexOf(gpId);
						if (idx >= 0) {
							otherParanetGrps.splice(idx, 1);
						}
						if (paranetGrps) {
							for (var __i_enFor3 = 0, __exp_enFor3 = paranetGrps, __len_enFor3 = __exp_enFor3.length;
									__i_enFor3 < __len_enFor3; ++__i_enFor3) {
								var sg = __exp_enFor3[__i_enFor3];
								if (!(otherParanetGrps.indexOf(sg)> -1)) {
									otherParanetGrps.push(sg);
								}
							}
						}
					}
				}
			}
		}
		if (grps.length==0) {
			bChanged = true;
			qs.itemNormalization = null;
		}
		return bChanged;
	}

	/**
	 * add query item to item normalization.
	 * @param {QuerySubject} qs
	 * @param {QueryItem} queryItem
	 * @param {ObjectFactory} objectFactory
	 */
	static addQueryItemToItemNormalization(qs, queryItem, objectFactory) {
		if (queryItem.hidden != null && queryItem.hidden) {
			return;
		}
		if (!qs.itemNormalization) {
			return;
		}
		if (!qs.itemNormalization.itemNormalizationGroup || qs.itemNormalization.itemNormalizationGroup.length==0) {
			return;
		}
		var jFunc = PropertySetter._getJSONFunctionDef(queryItem);
		if (!jFunc) {
			return;
		}
		if (RegularAggregateType.CALCULATED == queryItem.regularAggregate) {
			return;
		}
		var pkGrp = PropertySetter._getSimplePrimaryKeyGroup(qs.itemNormalization.itemNormalizationGroup);
		if (pkGrp) {
			if (queryItem.identifier == pkGrp.key.itemRef) {
				return;
			}
			if (pkGrp.attribute) {
				for (var __i_enFor0 = 0, __exp_enFor0 = pkGrp.attribute, __len_enFor0 = __exp_enFor0.length;
						__i_enFor0 < __len_enFor0; ++__i_enFor0) {
					var attr = __exp_enFor0[__i_enFor0];
					if (queryItem.identifier == attr.itemRef) {
						return;
					}
				}
			}
			PropertySetter._addNewAttributeToGroup(objectFactory, pkGrp, queryItem);
		} else {
			var func = jFunc["func"];
			var bGetIdsFromExpr = "customCalculation" == func;
			if ("split" == func) {
				var jP = PropertySetter._getJSONPropertyValue(queryItem, "_MUI_splitOrigin");
				if (jP) {
					jFunc = jP;
				}
			}
			var allIds = {};
			var idList = [];
			if (!bGetIdsFromExpr) {
				if (!(PropertySetter._getIdsFromPropertyJSONValue(idList, allIds, jFunc, qs.getIdentifier()))) {
					return;
				}
			} else {
				var ids = ItemScanner.collectIdentifiers(queryItem.getExpression());
				for (var __i_enFor1 = 0, __exp_enFor1 = ids, __len_enFor1 = __exp_enFor1.length;
						__i_enFor1 < __len_enFor1; ++__i_enFor1) {
					var id = __exp_enFor1[__i_enFor1];
					if (!(PropertySetter._addQueryItemIdParts(idList, id, allIds, qs.getIdentifier()))) {
						return;
					}
				}
			}
			if (idList.length == 0) {
				return;
			}
			for (var __i_enFor2 = 0, __exp_enFor2 = qs.itemNormalization.itemNormalizationGroup, __len_enFor2 = __exp_enFor2.length;
					__i_enFor2 < __len_enFor2; ++__i_enFor2) {
				var grp = __exp_enFor2[__i_enFor2];
				var n = 0;
				if (grp.key && grp.key.itemRef != null && allIds.hasOwnProperty(grp.key.itemRef)) {
					n++;
				}
				if (grp.attribute && !(grp.attribute.length==0)) {
					for (var __i_enFor3 = 0, __exp_enFor3 = grp.attribute, __len_enFor3 = __exp_enFor3.length;
							__i_enFor3 < __len_enFor3; ++__i_enFor3) {
						var a = __exp_enFor3[__i_enFor3];
						if (a.itemRef != null && allIds.hasOwnProperty(a.itemRef)) {
							n++;
						}
					}
				}
				if (n == idList.length) {
					PropertySetter._addNewAttributeToGroup(objectFactory, grp, queryItem);
					return;
				}
			}
		}
	}

	/**
	 * add a new attribute to the group.
	 * @param {ObjectFactory} objectFactory
	 * @param {ItemNormalizationGroupType} pkGrp
	 * @param {QueryItem} queryItem
	 */
	static _addNewAttributeToGroup(objectFactory, pkGrp, queryItem) {
		var newAttr = objectFactory.createItemNormalizationGroupTypeAttribute();
		newAttr.itemRef = queryItem.identifier;
		newAttr.sqlOperator = SqlOperatorType.MINIMUM;
		pkGrp.addAttribute(newAttr);
	}

	static _getSimplePrimaryKeyGroup(grps) {
		if (grps.length == 1) {
			var g = grps[0];
			if (g.key && g.key.getKeyConstraint() == KeyConstraintType.UNIQUE) {
				return g;
			}
			return null;
		}
		var pkGrp;
		var idToGrp = {};
		for (var __i_enFor0 = 0, __exp_enFor0 = grps, __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var g = __exp_enFor0[__i_enFor0];
			if (g.identifier == null) {
				return null;
			}
			if (!g.key) {
				return null;
			}
			if (g.key.getKeyConstraint() == KeyConstraintType.UNIQUE) {
				if (g.parentGroupRef && !(g.parentGroupRef.length==0) && g.key.getKeyComposition() == KeyCompositionType.INDEPENDENT) {
					return null;
				}
				if (!pkGrp) {
					pkGrp = g;
				} else {
					return null;
				}
			} else {
				if (g.attribute && !(g.attribute.length==0)) {
					return null;
				}
			}
			idToGrp[g.identifier] = g;
		}
		if (pkGrp) {
			var nChain = 1;
			var parentGrps = pkGrp.parentGroupRef;
			while (parentGrps && !(parentGrps.length==0)) {
				if (parentGrps.length > 1) {
					return null;
				}
				nChain++;
				parentGrps = idToGrp[parentGrps[0]].parentGroupRef;
			}
			if (nChain != grps.length) {
				return null;
			}
		}
		return pkGrp;
	}

	/**
	 * get ids from JSON property value (defined by MUI).
	 * @param {Object} allIds 	return all Ids.
	 * @param {Object} jFunc 		JSON.
	 */
	static _getIdsFromPropertyJSONValue(idList, allIds, jFunc, qsId) {
		if (!jFunc) {
			return false;
		}
		var basedObjId = jFunc["basedOnMoserObjectId"];
		if (basedObjId != null && !(basedObjId.length === 0)) {
			if (!(PropertySetter._addQueryItemId(idList, basedObjId, allIds, qsId))) {
				return false;
			}
		}
		var basedObj = jFunc["basedOnMoserObject"];
		if (basedObj != null && !(basedObj.length === 0)) {
			if (!(PropertySetter._addQueryItemId(idList, basedObj, allIds, qsId))) {
				return false;
			}
		}
		var operands = jFunc["elementOperands"];
		if (operands) {
			for (var __i_enFor0 = 0, __exp_enFor0 = operands, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var o = __exp_enFor0[__i_enFor0];
				var sId = o;
				if (!(sId.length === 0)) {
					if (!(PropertySetter._addQueryItemId(idList, sId, allIds, qsId))) {
						return false;
					}
				}
			}
		}
		var orgId = jFunc["originalColumnIdentifier"];
		if (orgId != null && !(orgId.length === 0)) {
			if (!(PropertySetter._addQueryItemId(idList, orgId, allIds, qsId))) {
				return false;
			}
		}
		return true;
	}

	static _addQueryItemId(idList, basedObj, allIds, qsId) {
		var parts = basedObj.split(new RegExp("\\."));
		return PropertySetter._addQueryItemIdParts(idList, parts, allIds, qsId);
	}

	static _addQueryItemIdParts(idList, parts, allIds, qsId) {
		if (parts.length == 1) {
			if (!(allIds.hasOwnProperty(parts[0]))) {
				allIds[parts[0]] = parts[0];
				idList.push(parts[0]);
			}
			return true;
		}
		if (parts.length == 2) {
			if (parts[0] == qsId) {
				if (!(allIds.hasOwnProperty(parts[1]))) {
					allIds[parts[1]] = parts[1];
					idList.push(parts[1]);
				}
				return true;
			}
		}
		return false;
	}
}


// WEBPACK FOOTER //
// ./src/generated/PropertySetter.js